export default __webpack_public_path__ + "static/media/campus (2).97ef4d33.jpeg";